import { STASH } from '../constants';

const publishStashLink = () => {
  const page = digitalData?.page.pageInfo.pageName || 'unknown';
  const settings = page + ': cards and accounts: view all';
  const DDO = {
    category: {
      primaryCategory: STASH
    },
    eventMode: STASH,
    eventInfo: {
      eventName: 'my account settings',
    },
    stash: {
      myAccount: { settings }
    }
  };

  digitalData.event = digitalData.event || [];
  digitalData.event.push(DDO);
};

// https://github.com/one-thd/ocm_pd_component_payment-method-card
export const paymentMethodCard = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('payment-method-card-view-all.click', publishStashLink);
};
